<template>
    <div>
      <input id="business_address" v-model="booking.businessType" name="business_address" type="hidden">
      <div v-if="!viewPage" class="p-left-4 mobile-no-p-left customer-mobile-m-left">
        <div>
          <div v-if="allObject.isCustomerEditable">
            <validation-provider v-slot="{errors}" name="Customer" :rules="false?'required':''">
              <select-customers
                  :can-see-customer="canSeeCustomer"
                  :logged-user="allObject.loggedUser"
                  v-model="booking.customer"
                  :item-type="itemType"
                  :can_add="allObject.canAddCustomer"
                  :can_edit="allObject.canEditCustomer"
                  :selected-customer-id="(allObject.event || {}).customer_id">
              </select-customers>
              <span class="text text-danger error-label">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div v-else>
            <p class="font-size-18 bold" style="margin-top: 30px; margin-bottom: 25px;">
              <span class="select-customers-dropdown-title">Customer</span>
            </p>
            <input :id="allObject.customerNameIdString" v-model="booking.customer.customer_name"
                   class="text_input edit-form-search autocomplete_search form-control" readonly
                   type="text"/>

            <input id="customer_id" v-model="booking.customer.customer_id" class="text_input required"
                   type="hidden"/>
          </div>
        </div>
      </div>

      <div v-if="!viewPage" class="clear-fix"></div>

      <div v-if="!viewPage" class="row p-left-4">

        <customer-properties v-model="booking.customer.properties"
                             :customer="booking.customer"
                             :tradingId="booking.tradingId"
                             :booking-id="(allObject.event || {}).inquiry_id"
                             :country-code="countryCode"
                             :country-key="countryKey"
                             :date-format="allObject.dateFormat"
                             type="inquiry">
        </customer-properties>
      </div>

      <div v-if="!viewPage" class="row" style="margin-right: -18px">
        <div  class="forms-wrapper">
          <div class="row">
            <div class="col-md-12 mobile-position">
              <div class="ibox float-e-margins remove-margin-bottom-services mobile-no-m-bottom">
                <div class="customer-data-ibox">
                  <div id="booking_address_block" class="ibox float-e-margins">
                    <div class="ibox-content location-ibox-content" style="border: none">
                      <booking-location-div
                          v-model="booking.bookingLocationData"
                          :address-label='allObject.address_label'
                           :booking-addresses-vue='allObject.inquiryAddress'
                          :business-addresses='allObject.business_addresses'
                          :item-type="itemType"
                          :company-business-type-all="businessTypeAll"
                          :inquiry-business-address="businessAddress"
                          :inquiry-business-type="businessType" @business-type-changed="businessTypeChanged">
                      </booking-location-div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

        <open-location-component-as-popup
            v-model="booking.bookingLocationData"
            v-show="itemType!=='gift_card' && booking.bookingStatusId !== getGiftCardBookingStatusId "
            v-if="viewPage"
            :address-label='allObject.address_label'
            :item-id="booking.inquiryId"
            :services="booking.services"
            :item-type="itemType"
            :changed-visits="changedVisits"
            :booking-addresses-vue='allObject.inquiryAddress'
            :business-addresses='allObject.business_addresses'
            :online-virtual-meeting-link="allObject.booking ? allObject.booking.online_virtual_meeting_link  :''"
            :company-business-type-all="businessTypeAll"
            :inquiry-business-address="businessAddress"
            :inquiry-business-type="booking.businessType"  >
        </open-location-component-as-popup>

        <div class="row">
                <services
                    v-model="booking.services"
                    from="inquiry"
                    :view-page="viewPage"
                    :item-type='itemType'
                    :item-id="(allObject.event || {}).inquiry_id"
                    :company-id="allObject.company.company_id"
                    :currency='allObject.currency'
                    :date-format="allObject.dateFormat"
                    :logged-user="allObject.loggedUser"
                    :time-format="allObject.timeFormat">
                </services>

            <div class="ibox-content border-none private-notes-inquiry-mop" style="border-top: 15px solid #f3f3f4;" v-if="viewPage">

                <div class="row">
                    <div class="col-md-12 white-bg additional-comments">
                        <div>
                            <private-notes v-model="booking.comment"
                                           :view-page = "viewPage"
                                           :item-type='itemType'
                                           :booking-id="(allObject.event || {}).inquiry_id"
                                           :business-type-prop="businessTypeAll"
                                           :inquiry-business-type="booking.businessType">
                            </private-notes>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from 'vee-validate';
import Forms from "../../Forms/components/Forms.vue";
import {EventBus} from "@/events/event-bus";

export default {
    name: 'InquiryForm',
    props: {
        canSeeCustomer: null,
        loggedUser: null,
        viewPage:false,
        from: String,
        allObject: {
            type:Object
        },
    },
    components: {
        Forms,
        ValidationProvider,
        ValidationObserver
    },
    computed: {
        itemType() {
                return 'inquiry'
        },
      canSeeCustomer(){
        return (
          this.allObject.company.show_customer_number_in_app &&
          this.allObject.loggedUser.role_id == 1
        )
      },
    },
    data() {
        return {
            booking: {
                actionUrl: (this.allObject || {}).actionUrl ?? null,
                inquiryId: (this.allObject.event || {}).inquiry_id ?? null,
                subscriberTrial: this.allObject.subscriber_trial??0,
                referral: "add" ?? null,
                voucherId: (this.allObject.voucher || {}).voucher_id ?? null,
                bookingStatus: (this.allObject.event || {}).status ?? null,
                bookingStatusId: (this.allObject.event || {}).status_id ?? 4,
                summary: this.allObject.bookingPaymentSummary ?? {},
                id: (this.allObject.event || {}).booking_id,
                forms: [],
                services: [],
                businessType: (this.allObject.event || {}).business_type ?? (this.allObject.company || {}).business_type_default,
                description: (this.allObject.event || {}).description ?? null,
                comment: (this.allObject.event || {}).comment ?? null,
                ownerId: (this.allObject.event || {}).created_by ?? null,
                tradingId: (this.allObject.event || {}).trading_name_id ?? null,
                sourceId: (this.allObject.event || {}).source_id ?? null,
                bookingLocationData:(this.allObject || {}).bookingAddress ?? {},
                cancellationFee: (this.allObject.event || {}).cancellation_fee ?? null,
                callOutFee: (this.allObject.event || {}).call_out_fee ?? null,
                customer: {
                  customer_id: (this.allObject.event || {}).customer_id ?? 0,
                  customer_name: (this.allObject.event || {}).customer_name ?? null,
                  has_bill_payer:this.allObject.has_bill_payer?? 0,
                  different_bill_payer:(this.allObject.event || {}).different_bill_payer === 1,
                  properties: [],
                },
            },
            countryCode: this.allObject.country_code ?? null,
            countryKey:this.allObject.country_key ?? null,
            estimateStatus: this.allObject.toEstimate ??{} ,
            invoiceStatus: this.allObject.toInvoice ?? {},
            giftCardStatus: this.allObject.gift_card ??{},
            todoStatus: this.allObject.company.statuses.TO_DO ?? {},
            sourceIds: this.allObject.source_ids,
            businessAddress: (this.allObject.event || {}).business_address ?? null,
            businessTypeAll: this.allObject.company.business_type ?? null,
            businessType: (this.allObject.event || {}).business_type ?? null,
            future_date : true,
            end_dates : [],
            dates : [],
            times : [],
            end_times : [],
            dates_time_zone : [],
        }
    },
    methods: {
        async submit () {
        },

        businessTypeChanged(business_type){

            this.booking.businessType = business_type;
            if (business_type === 'fixed') {
                this.booking.businessType =$("#business_addresses option:selected").val();
            }
        }
    },
    mounted() {
        EventBus.$on('onBusinessTypeChanged', business_type => {

            this.booking.businessType = business_type;
            if (business_type === 'fixed') {
                this.booking.businessType =$("#business_addresses option:selected").val();
            }
        });
    }
}

</script>

<style scoped>

.booking-pricing-ibox {
    border: none;
    padding-top: 0;
}

@import "tom-select/dist/css/tom-select.min.css";
@import "tom-select/dist/css/tom-select.bootstrap5.min.css";
</style>